import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Typography, Spin, Row, Col } from '@app/ui';
import { InfoCircleFilled } from '@ant-design/icons';

interface CsvConfirmationModalProps {
    title: string;
    onClose: () => void;
    content: React.ReactNode;
    buttonContent?: string | React.ReactNode;
    isVisible: boolean;
}

const CsvConfirmationModal = ({
    title,
    onClose,
    content,
    buttonContent,
    isVisible,
}: CsvConfirmationModalProps) => {
    const { t } = useTranslation('measurement');
    const buttonLabel =
        buttonContent ?? t('socialMediaExposure.modals.minimize');
    return (
        <Modal
            title={
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                    }}
                >
                    <InfoCircleFilled
                        style={{
                            color: '#009FDF',
                            fontSize: 20,
                        }}
                    />
                    <Typography.Text style={{ lineHeight: '20px' }}>
                        {title}
                    </Typography.Text>
                </div>
            }
            visible={isVisible}
            onCancel={onClose}
            footer={[
                <Button key="close" type="primary" onClick={onClose}>
                    {buttonLabel}
                </Button>,
            ]}
            centered
        >
            <Row justify="center" align="middle">
                <Col
                    span={24}
                    style={{ textAlign: 'center', marginBottom: 20 }}
                >
                    <Spin size="large" />
                </Col>
                <Col span={24} style={{ textAlign: 'center' }}>
                    <Typography.Text style={{ color: '#009FDF' }}>
                        {content}
                    </Typography.Text>
                </Col>
            </Row>
        </Modal>
    );
};

export default CsvConfirmationModal;
